module.exports = __webpack_public_path__ + "img/social_expert.9841cc1c.svg";